export default __webpack_public_path__ + "media/zurb/img/work/client-logo-large-114830db9cc7ecaa0994c688f18ad3b7.jpg";